import React from 'react';
import './index.css';
import Header from './Header';
import Parts from './Parts';
import Anchor from './anchor'
import AOS from 'aos';
import 'aos/dist/aos.css';
import Books from './pages/Books';
import { HashRouter as Router, Route} from "react-router-dom";
import Notes from './pages/Notes';
import Syllabus from './pages/Syllabus';
import qpapers from './pages/Question-papers';
import implinks from './pages/Imp-Links';
import About from './pages/Aboutus';



class App extends React.Component{

  constructor(props){
    super(props);
    this.state = {
      status : 1,
    }
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick(){
    this.setState((previousState)=>{
      return{
        status : previousState.status + 1,
      }
    })
  }

  componentDidMount(){
    
    AOS.init({
      duration: 2000
    })

  }
  render() {
    return(
    <div className= "App">
      <Header handleClick={this.handleClick} show = {this.state.status}/>
      <Anchor/>
      <Router>
          <Route path="/" component={Parts} exact/>
          <Route path="/Books" component={Books} />
          <Route path="/Notes" component={Notes}/>
          <Route path="/Syllabus" component={Syllabus} />
          <Route path="/Question-papers" component={qpapers} />
          <Route path="/Imp-Links" component={implinks} />
          <Route path="/about" component={About} />
      </Router>
    </div>)
  }
};
export default App;
